import React from "react"; 

const Loader = () => {
  return (
    <div className="p-6 space-y-6 bg-gray-50">
      {/* Spinning Company Logo */}
     

      {/* Content Placeholder */}
      <div className="space-y-4">
        {/* Title Placeholder */}
        <div className="w-3/4 h-6 bg-gray-300 rounded-md"></div>

        {/* Image Placeholder */}
        <div className="w-full h-48 bg-gray-300 rounded-lg"></div>

        {/* Paragraph Placeholder */}
        <div className="space-y-2">
          <div className="w-full h-4 bg-gray-300 rounded-md"></div>
          <div className="w-full h-4 bg-gray-300 rounded-md"></div>
          <div className="w-5/6 h-4 bg-gray-300 rounded-md"></div>
        </div>

        <div className="w-3/4 h-6 bg-gray-300 rounded-md"></div>

{/* Image Placeholder */}
<div className="w-full h-48 bg-gray-300 rounded-lg"></div>

{/* Paragraph Placeholder */}
<div className="space-y-2">
  <div className="w-full h-4 bg-gray-300 rounded-md"></div>
  <div className="w-full h-4 bg-gray-300 rounded-md"></div>
  <div className="w-5/6 h-4 bg-gray-300 rounded-md"></div>
</div>
      </div>
    </div>
  );
};

export default Loader;
